import LinkedEntityPreview from './LinkedEntityPreview';

export default interface LinkedEntity {
    Id: string;
    WebLink: string;
    EntityType: string;
    EntitySubtype: string;
    DisplayName: string;
    Preview?: LinkedEntityPreview;
}

export const EMAIL_ENTITY_TYPE = 'message';
export const DRAGGED_EMAIL_ENTITY_SUBTYPE = 'dragged_email';
export const SUGGESTED_TASK_ENTITY_SUBTYPE = 'suggestion_from_email';
